import {
  Ellipsis,
  KeyRound,
  LogOut,
  Pencil,
  Trash2,
  UserCheck,
  UserX,
} from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function UserTableActions({
  user,
  canEditUser = false,
  canDeleteUser = false,
  canResetPassword = false,
  canDeactivateUser = false,
  onEditUser = () => {},
  onDeleteUser = () => {},
  onResetPassword = () => {},
  onDeactivateUser = () => {},
  onReactivateUser = () => {},
  onForceLogout = () => {},
}) {
  const isActive = user.status === "active" || !user.status;

  if (
    !canEditUser &&
    !canDeleteUser &&
    !canResetPassword &&
    !canDeactivateUser
  ) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="User actions"
        className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
      >
        <Ellipsis />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto">
        {canEditUser && (
          <DropdownMenuItem onClick={() => onEditUser(user)}>
            <Pencil />
            Edit User
          </DropdownMenuItem>
        )}
        {canResetPassword && (
          <DropdownMenuItem onClick={() => onResetPassword(user)}>
            <KeyRound />
            Reset Password
          </DropdownMenuItem>
        )}
        {canDeactivateUser && isActive && (
          <DropdownMenuItem onClick={() => onDeactivateUser(user)}>
            <UserX />
            Deactivate User
          </DropdownMenuItem>
        )}
        {canDeactivateUser && !isActive && (
          <DropdownMenuItem onClick={() => onReactivateUser(user)}>
            <UserCheck />
            Reactivate User
          </DropdownMenuItem>
        )}
        {canEditUser && (
          <DropdownMenuItem onClick={() => onForceLogout(user)}>
            <LogOut />
            Force Logout
          </DropdownMenuItem>
        )}
        {canDeleteUser && (
          <DropdownMenuItem
            variant="destructive"
            onClick={() => onDeleteUser(user)}
          >
            <Trash2 />
            Delete User
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
